import { gql } from '@apollo/client';
import { AddUserClaimProps, RemoveUserClaimProps } from './claim.types';
import { GET_USER_PERMISSIONS } from '../../queries';

export const ADD_USER_PERMISSION = gql`
  mutation AddUserClaims($claim: String!, $email: String!) {
    addUserPermission(claim: $claim, email: $email)
  }
`;

export function addUserPermission({
  client,
  claim,
  email,
}: AddUserClaimProps) {
  return client?.mutate<{ addUserPermission: string }>({
    mutation: ADD_USER_PERMISSION,
    variables: {
      claim,
      email,
    },
    refetchQueries: [
      GET_USER_PERMISSIONS,
    ],
  });
}

export const REMOVE_USER_PERMISSION = gql`
  mutation RemoveUserClaims($claim: String!, $email: String!) {
    removeUserPermission(claim: $claim, email: $email)
  }
`;

export function removeUserPermission({
  client,
  claim,
  email,
}: RemoveUserClaimProps) {
  return client?.mutate<{ removeUserPermissionMutation: string }>({
    mutation: REMOVE_USER_PERMISSION,
    variables: {
      claim,
      email,
    },
    refetchQueries: [
      GET_USER_PERMISSIONS,
    ],
  });
}
